import {SFDC_ENGAGEMENT_CONSTANTS, SFDC_ENGAGEMENT_API_URL} from './constantsString';
/**
 * Creates a new engagement record.
 * @param {*} payload - The engagement data to send.
 * @returns 
 */

/**
 * Creates a new engagement record in Salesforce.
 * This function sends a POST request to the Salesforce Engagement API with the provided payload.
 * The payload should include all necessary fields as defined in SFDC_ENGAGEMENT_CONSTANTS.
 * @param {Object} payload - The engagement data to send.
 * @return {void}
 * @throws {Error} If the fetch request fails or the response is not ok.
 * 
 * Example payload structure:
 * {
    emailAddress: "<USER_EMAIL_ADDRESS>",
    originURL: "The tool URL",
    engagementCreationDate: "Dynamic based on the creation date"
  }
 */

export const create_sfdc_engagement = payload => {
  const data = {
    ...SFDC_ENGAGEMENT_CONSTANTS,
    ...payload,
  };

  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  fetch(SFDC_ENGAGEMENT_API_URL, { method: "POST", body: formData })
    .then(response => {
      if (!response.ok) {
        console.log(`EngagementURL - Report HTTP error! status: ${response.status}`);
      }
    })
    .catch(error => {
      console.log("EngagementURL - Report error:", error);
    });
  return;
};